import React, { useState, useContext } from 'react';
import { WebSocketContext } from '../utils/SocketContext';
import '../css/Login.css';

const Login = () => {
  const { socket } = useContext(WebSocketContext);
  const [number, setNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [step, setStep] = useState(1); // Step 1: Number input, Step 2: OTP input
  const [sending, setSending] = useState(false);

  const validateNumber = (num) => /^[6-9]\d{9}$/.test(num);

  const handleSendOtp = () => {
    if (!validateNumber(number)) {
      alert('Please enter a valid 10-digit Indian mobile number.');
      return;
    }

    if (!socket) {
      alert('Socket not initialized.');
      return;
    }

    setSending(true);
    socket.send(JSON.stringify({ command: 'send_otp', number }));
    console.log('Sending')
    setTimeout(() => {
      setSending(false);
      setStep(2);
    }, 2000);
  };

  const handleVerifyOtp = () => {
    if (!otp) {
      alert('Please enter the OTP.');
      return;
    }

    if (!socket) {
      alert('Socket not initialized.');
      return;
    }

    setSending(true);
    socket.send(JSON.stringify({ command: 'verify_otp', otp, number }));
    setTimeout(() => {
      setSending(false);
      alert('OTP Verified!');
    }, 2000);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        {step === 1 ? (
          <>
            <h1>Enter Your WhatsApp Number</h1>
            <input
              type="text"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              placeholder="10-digit number"
              maxLength={10}
            />
            <button onClick={handleSendOtp} disabled={sending}>
              {sending ? 'Sending...' : 'Send OTP'}
            </button>
          </>
        ) : (
          <>
            <h1>Enter OTP</h1>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
              maxLength={6}
            />
            <button onClick={handleVerifyOtp} disabled={sending}>
              {sending ? 'Verifying...' : 'Verify OTP'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
